// extracted by mini-css-extract-plugin
module.exports = {"GiveFeedbackcontainer":"GiveFeedback_GiveFeedbackcontainer__4p2iY"};